import { Container } from "@mantine/core";
import { Outlet } from "react-router-dom";
import styles from "./styles/Layout.module.css";
import { Footer } from "./Footer";

export const Layout = () => {
    return (
        <>
            <div className={"main " + styles.main}>
                <Container size="lg">
                    <Outlet />
                </Container>
            </div>
            <Footer />
        </>
    );
};
